var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDriveFolderUpload = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Drive folder upload",
    clipPath: "url(#clip0_22072_89950)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M50.5 15.0303H30.5L25.5 10.0303H10.5C7.75 10.0303 5.525 12.2803 5.525 15.0303L5.5 45.0303C5.5 47.7803 7.75 50.0303 10.5 50.0303H50.5C53.25 50.0303 55.5 47.7803 55.5 45.0303V20.0303C55.5 17.2803 53.25 15.0303 50.5 15.0303ZM50.5 45.0303H10.5V20.0303H50.5V45.0303ZM20.5 32.5553L24.025 36.0803L28 32.1303V42.5303H33V32.1303L36.975 36.1053L40.5 32.5553L30.525 22.5303L20.5 32.5553Z",
    fill: "#4846DC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22072_89950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0.5 0.0302734)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDriveFolderUpload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/drive_folder_upload.ce67236c.svg";
export { ForwardRef as ReactComponent };